import { LoaderScreen } from '@/components/Elements';
import { SetupLayout } from '../components/SetupLayout';
import { useProfileSetup } from '@/features/setup/hooks/useProfileSetup';
import { SimpleLayout } from '@/components/Layout';

export const ProfilePage = () => {
  const { user, isLoading, getFormProps, getFormComponent } = useProfileSetup();

  if (isLoading || !user?.signupInitiation) {
    return (
      <SimpleLayout>
        <LoaderScreen />
      </SimpleLayout>
    );
  }

  const FormComponent = getFormComponent(user.signupInitiation);
  const formProps = getFormProps(user.signupInitiation);

  return (
    <SetupLayout>
      <FormComponent {...formProps} />
    </SetupLayout>
  );
};
